import { render, staticRenderFns } from "./Weekday.vue?vue&type=template&id=f01a0e90&scoped=true&"
import script from "./Weekday.vue?vue&type=script&lang=js&"
export * from "./Weekday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01a0e90",
  null
  
)

export default component.exports